import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import {
  FeatureSet,
  FeatureSetService,
} from '../../../services/feature-set.service';

@Component({
  selector: 'app-feature-set-dialog',
  templateUrl: './feature-set-dialog.component.html',
  styleUrl: './feature-set-dialog.component.scss',
})
export class FeatureSetDialogComponent implements OnInit {
  @Input() featureSet: FeatureSet | null = null;
  @Input() availablePermissions: string[] = [];

  name = '';
  permissions: string[] = [];
  saving = false;

  constructor(
    protected dialogRef: NbDialogRef<FeatureSetDialogComponent>,
    protected featureSetService: FeatureSetService,
    protected toastr: NbToastrService,
  ) {}

  ngOnInit(): void {
    if (this.featureSet) {
      this.name = this.featureSet.name;
      this.permissions = [...this.featureSet.permissions];
    }
  }

  togglePermission(perm: string) {
    const idx = this.permissions.indexOf(perm);
    if (idx >= 0) {
      this.permissions.splice(idx, 1);
    } else {
      this.permissions.push(perm);
    }
  }

  hasPermission(perm: string): boolean {
    return this.permissions.includes(perm);
  }

  save() {
    if (!this.name.trim() || this.saving) return;
    this.saving = true;
    const obs = this.featureSet
      ? this.featureSetService.updateFeatureSet(this.featureSet.id, {
          name: this.name,
          permissions: this.permissions,
        })
      : this.featureSetService.createFeatureSet(this.name, this.permissions);

    obs.subscribe({
      next: () => {
        this.toastr.success(
          this.featureSet ? 'Feature Set aktualisiert' : 'Feature Set erstellt',
          'Gespeichert',
        );
        this.dialogRef.close(true);
      },
      error: () => {
        this.saving = false;
      },
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
